export default function Footer() {
  return (
    <footer className="footer d-flex align-items-center">
      <div>
        <strong>Stride Early Learning</strong> · Family Portal Admin &copy;{" "}
        {new Date().getFullYear()}
      </div>
      <div className="ms-auto small" style={{ color: "var(--bw-text-dim)" }}>
        v1.0
      </div>
    </footer>
  );
}
